import { Card } from '@norges-domstoler/dds-components';
import { useLinkClickHandler } from 'react-router-dom';
import { getRelativeUrl } from '../Utils';
import { useExternalUrl } from './useExternalUrl';

type DDSNavigationCardProps = Extract<React.ComponentProps<typeof Card>, { cardType: 'navigation' }>;

type NavigationCardProps = Omit<DDSNavigationCardProps, 'htmlProps' | 'cardType'> & {
    useBrowserNavigation?: boolean;
    scrollToTop?: boolean;
};

export default function NavigationCard(props: NavigationCardProps) {
    const { children, useBrowserNavigation, href, scrollToTop, ...rest } = props;
    const url = getRelativeUrl(href);
    const linkClickHandler = useLinkClickHandler(url);
    const isExternalUrl = useExternalUrl(href);

    const handleOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (!isExternalUrl) {
            if (scrollToTop) {
                document.documentElement.scrollTop = 0;
            }
            return linkClickHandler(e);
        }
    };

    return (
        <Card
            {...rest}
            href={isExternalUrl ? href : url}
            cardType="navigation"
            style={{ display: 'block' }}
            htmlProps={useBrowserNavigation ? undefined : { onClick: handleOnClick }}
        >
            {children}
        </Card>
    );
}
